(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  // Sepet AJAX ile guncelleniyor (cart-custom.js ara toplam metnini yeniden
  // yaziyor). Kendi kodlarina dokunmamak icin ara toplami izliyoruz.
  document.querySelectorAll('.mm-cart-wholesale').forEach(function (msg) {
    var subtotal = document.querySelector('[data-cart-render="total_price_money_with_currency"]');
    if (!subtotal) return;

    var threshold = parseInt(msg.dataset.wholesaleMinor, 10);
    if (!threshold || threshold < 1) return;

    var toMinorUnits = function (text) {
      var digits = (text || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
      var value = parseFloat(digits);
      return isNaN(value) ? null : Math.round(value * 100);
    };

    var sync = function () {
      var total = toMinorUnits(subtotal.textContent);
      // "Please wait..." gibi ara durumlarda mevcut hali koru
      if (total === null) return;
      msg.hidden = total <= threshold;
    };

    new MutationObserver(sync).observe(subtotal, { childList: true, characterData: true, subtree: true });
    sync();
  });

  // ---------------------------------------------------------------------------
  // Teslimat tarihi secici (Excel satir 8). Kural kaynaklari section schema'da.
  // ---------------------------------------------------------------------------
  (function () {
    var root = document.querySelector('[data-mm-dd]');
    if (!root) return;

    var CUTOFF_H = parseInt(root.dataset.cutoff, 10);
    var LEAD     = parseInt(root.dataset.leadDays, 10);
    var WEEKS    = parseInt(root.dataset.weeksAhead, 10);
    var ALLOWED  = (root.dataset.weekdays || '2,3,4,5').split(',')
                     .map(function (s) { return parseInt(s, 10); })
                     .filter(function (n) { return n >= 1 && n <= 7; });
    var HOLIDAYS = (root.dataset.holidays || '').split(',')
                     .map(function (s) { return s.trim(); })
                     .filter(function (s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); });

    if (!ALLOWED.length || isNaN(LEAD) || isNaN(WEEKS)) return;

    var HOL = {};
    HOLIDAYS.forEach(function (h) { HOL[h] = true; });

    // Tarihler UTC olarak tutuluyor: yaz saati gecisi gun kaydirmasin diye.
    function mk(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
    function iso(d) { return d.toISOString().slice(0, 10); }
    function addDays(d, n) { return new Date(d.getTime() + n * 86400000); }
    function isoDay(d) { var w = d.getUTCDay(); return w === 0 ? 7 : w; }  // 1=Pzt..7=Paz

    // Musteri hangi saat diliminde olursa olsun cut-off Londra saatiyle isler.
    function londonNow() {
      var p = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      // en-GB 24 saat biciminde gece yarisini "24" verebiliyor
      var h = parseInt(p.hour, 10) % 24;
      return { day: mk(+p.year, +p.month, +p.day), hour: h };
    }

    function isWorkingDay(d) { return isoDay(d) <= 5 && !HOL[iso(d)]; }
    function nextWorkingDay(d) {
      var x = addDays(d, 1), guard = 0;
      while (!isWorkingDay(x) && guard++ < 400) x = addDays(x, 1);
      return x;
    }
    function addWorkingDays(d, n) {
      var x = d;
      for (var i = 0; i < n; i++) x = nextWorkingDay(x);
      return x;
    }

    // A15, 26 Agustos'ta DEGISTI.
    // Eski kural: tatilin dustugu HAFTANIN TAMAMI kapaliydi. Bu, 7 gunluk
    // pencereyle carpisip yilda 39 gun SIFIR secenek birakiyordu (Noel'de
    // 12 gun, Paskalya'da 12 gun). Sarah: "it doesn't need to close for the
    // whole week, just that day... This day and the day after would not be
    // available for deliveries."
    // Yeni kural: tatil gunu + ERTESI GUN kapali. Ertesi gunu kapatmak
    // ayara bagli (dd_block_day_after), cunku bu kismi sonradan eklendi.
    function mondayOf(d) { return addDays(d, -(isoDay(d) - 1)); }
    var BLOCK_NEXT = root.dataset.blockDayAfter === 'true';
    var BLACKOUT = {};
    HOLIDAYS.forEach(function (h) {
      var p = h.split('-');
      var d = mk(+p[0], +p[1], +p[2]);
      BLACKOUT[iso(d)] = true;
      if (BLOCK_NEXT) BLACKOUT[iso(addDays(d, 1))] = true;
    });

    function buildDates() {
      var now = londonNow();
      // Cut-off gectiyse ya da bugun is gunu degilse, sayim ertesi is gununden
      var start = (now.hour >= CUTOFF_H || !isWorkingDay(now.day))
                    ? nextWorkingDay(now.day)
                    : now.day;
      var earliest = addWorkingDays(start, LEAD);
      var limit    = addDays(now.day, WEEKS * 7);   // A17: bugunden itibaren N hafta

      var out = [], cur = earliest, guard = 0;
      while (cur.getTime() <= limit.getTime() && guard++ < 400) {
        if (ALLOWED.indexOf(isoDay(cur)) !== -1 &&
            !BLACKOUT[iso(cur)] &&
            !HOL[iso(cur)]) {
          out.push(new Date(cur.getTime()));
        }
        cur = addDays(cur, 1);
      }
      return out;
    }

    var slotsEl = root.querySelector('[data-mm-dd-slots]');
    var noneEl  = root.querySelector('[data-mm-dd-none]');
    var inputEl = root.querySelector('[data-mm-dd-input]');
    var termsEl = root.querySelector('[data-mm-dd-terms]');
    var errorEl = root.querySelector('[data-mm-dd-error]');
    var btn     = document.getElementById('checkout');

    var fmtDay  = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
    var fmtFull = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

    var dates = buildDates();

    if (!dates.length) {
      noneEl.hidden = false;
    } else {
      var lastWeek = null;
      dates.forEach(function (d) {
        var wk = iso(mondayOf(d));
        if (wk !== lastWeek) {
          lastWeek = wk;
          var h = document.createElement('div');
          h.className = 'mm-dd__week';
          h.textContent = 'Week of ' + fmtDay.format(mondayOf(d));
          slotsEl.appendChild(h);
        }
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mm-dd__slot';
        b.setAttribute('aria-pressed', 'false');
        b.dataset.value = iso(d);
        b.textContent = fmtDay.format(d);
        b.title = fmtFull.format(d);
        slotsEl.appendChild(b);
      });
    }

    slotsEl.addEventListener('click', function (e) {
      var b = e.target.closest('.mm-dd__slot');
      if (!b) return;
      slotsEl.querySelectorAll('.mm-dd__slot').forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === b));
      });
      // Admin'de okunacak deger: hem insan hem makine okuyabilsin diye ISO
      inputEl.value = b.dataset.value;
      sync();
    });

    // -------------------------------------------------------------------
    // Posta kodu katmani (Quiver cakismasi, katman 1)
    //
    // Uc durum var:
    //   pcState = 'off'      Quiver kapali, blok hic basilmadi. Bugunku davranis.
    //   pcState = 'waiting'  Quiver acik ama musteri henuz posta kodu girmedi.
    //                        Takvim gizli, checkout bloke, "posta kodunu gir" yaziyor.
    //   pcState = 'london'   Londra. Takvim ve onay kutusu gizli, Quiver mesaji
    //                        goruluyor, TARIH ISTENMIYOR, checkout serbest.
    //   pcState = 'uk'       Londra disi. Bugunku davranisin aynisi.
    // -------------------------------------------------------------------
    var pcRoot    = root.querySelector('[data-mm-dd-pc]');
    var pcInput   = root.querySelector('[data-mm-dd-pc-input]');
    var pcBtn     = root.querySelector('[data-mm-dd-pc-btn]');
    var pcInvalid = root.querySelector('[data-mm-dd-pc-invalid]');
    var londonEl  = root.querySelector('[data-mm-dd-london]');
    var termsWrap = termsEl ? termsEl.closest('.mm-dd__terms') : null;

    var bulkEl = root.querySelector('[data-mm-dd-bulk]');

    var LONDON = (pcRoot ? (pcRoot.dataset.london || '') : '')
                   .split(',')
                   .map(function (x) { return x.trim().toUpperCase(); })
                   .filter(Boolean);

    // 5 litre gibi, Quiver'in tasimadigi ve depodan giden varyantlar
    var BULK = (root.dataset.bulkVariants || '')
                 .split(',')
                 .map(function (x) { return x.trim(); })
                 .filter(Boolean);

    var pcState = pcRoot ? 'waiting' : 'off';
    var pcOutward = null;

    // OUTWARD CODE, alan degil. "SW3 5EL" -> "SW3", "E14 5AH" -> "E14",
    // "EC1V 9HQ" -> "EC1V", "W1F 8ZN" -> "W1F". Sadece outward de kabul: "SW3".
    //
    // 🔴 Neden alan degil: Quiver E alaninin hepsini tasimiyor (E1 var, E4 yok).
    // Alan duzeyinde eslestirirsek kapsam disi musteriye takvimi gizleriz ve
    // checkout'ta Quiver da cikmazsa tarihsiz kalir. Liste QUIVER-POSTCODES-*.md.
    //
    // Ic kisim (inward) her zaman rakam + iki harf. Regex onu opsiyonel tutuyor,
    // boylece musteri yalnizca outward yazsa da calisiyor.
    function outwardOf(raw) {
      var v = (raw || '').toUpperCase().replace(/\s+/g, '');
      var m = v.match(/^([A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2})?$/);
      return m ? m[1] : null;
    }

    // Sepette bulk varyant var mi. Satirlar data-variant-id tasiyor, ek markup yok.
    function hasBulk() {
      if (!BULK.length) return false;
      var rows = document.querySelectorAll('.cart-line[data-variant-id]');
      for (var i = 0; i < rows.length; i++) {
        if (BULK.indexOf(String(rows[i].dataset.variantId)) !== -1) return true;
      }
      return false;
    }

    // Karar tek yerde: posta kodu + sepet icerigi.
    function decidePc() {
      if (!pcOutward) { pcState = 'waiting'; return; }
      var inLondon = LONDON.indexOf(pcOutward) !== -1;
      if (inLondon && hasBulk()) pcState = 'london-bulk';
      else if (inLondon)         pcState = 'london';
      else                       pcState = 'uk';
    }

    // 'london'      Quiver tasiyor -> takvim gizli, tarih istenmiyor
    // 'london-bulk' Londra ama sepette 5 litre var -> Quiver tasimiyor, depodan
    //               gidiyor, yani TARIH GEREKLI. Takvim gosterilir.
    // 'uk'          Londra disi -> bugunku davranis
    // 'waiting'     posta kodu girilmedi -> takvim gizli, checkout bloke
    function applyPcState() {
      if (pcState === 'off') return;
      var isLondon  = pcState === 'london';
      var isBulk    = pcState === 'london-bulk';
      var isWaiting = pcState === 'waiting';
      var hideCal   = isLondon || isWaiting;

      if (londonEl) londonEl.hidden = !isLondon;
      if (bulkEl)   bulkEl.hidden   = !isBulk;
      slotsEl.hidden = hideCal;
      if (termsWrap) termsWrap.hidden = hideCal;
      if (noneEl && hideCal) noneEl.hidden = true;
      if (noneEl && !hideCal) noneEl.hidden = dates.length > 0;
    }

    if (pcBtn) {
      var checkPc = function () {
        var outward = outwardOf(pcInput.value);
        if (!outward) {
          pcInvalid.hidden = false;
          pcOutward = null;
          pcState = 'waiting';
          applyPcState();
          sync();
          return;
        }
        pcInvalid.hidden = true;
        pcOutward = outward;
        decidePc();
        applyPcState();
        sync();
      };

      // Sepet AJAX ile degisebiliyor (5 litre eklenir/cikarilir). Karar sepete de
      // bagli oldugu icin satirlar degisince yeniden degerlendiriliyor.
      var itemsWrap = document.getElementById('main-cart-items');
      if (itemsWrap && window.MutationObserver) {
        new MutationObserver(function () {
          if (!pcOutward) return;
          var before = pcState;
          decidePc();
          if (pcState !== before) { applyPcState(); sync(); }
        }).observe(itemsWrap, { childList: true, subtree: true });
      }
      pcBtn.addEventListener('click', checkPc);
      pcInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); checkPc(); }
      });
      // Posta kodu degistirilirse karar sifirlanir, eski karar yaniltmasin
      pcInput.addEventListener('input', function () {
        if (pcState === 'waiting') return;
        pcOutward = null;
        pcState = 'waiting';
        pcInvalid.hidden = true;
        applyPcState();
        sync();
      });
    }

    // Londra'da tarih ISTENMIYOR: Quiver slotu checkout'ta seciliyor.
    // Posta kodu girilmeden checkout'a gecis yok, cunku hangi dalda
    // oldugumuzu bilmiyoruz.
    function ready() {
      if (pcState === 'london') return true;
      if (pcState === 'waiting') return false;
      return !!inputEl.value && termsEl.checked;
    }

    // 🔴 Bu blokta (javascript etiketi icinde) Liquid CALISMAZ. Sus parantezli
    // Liquid ifadesi yazarsan ham metin olarak JS'e girer ve tum blok sozdizimi
    // hatasiyla oler. Metin data attribute'undan okunuyor, orasi render ediliyor.
    // Bkz. HANDOFF tuzak 3.8.
    var ERR_DATE = errorEl ? errorEl.textContent : '';
    var ERR_PC   = root.dataset.pcPrompt || 'Enter your postcode to see delivery options.';

    function sync() {
      if (!btn) return;
      var ok = ready();
      btn.classList.toggle('mm-dd-blocked', !ok);
      btn.setAttribute('aria-disabled', String(!ok));
      // Hangi sebeple bloke oldugumuzu dogru soyle
      if (errorEl) errorEl.textContent = (pcState === 'waiting') ? ERR_PC : ERR_DATE;
      if (ok) errorEl.hidden = true;
    }

    applyPcState();
    termsEl.addEventListener('change', sync);

    // Buton form submit ediyor; kosul saglanmadan gecisi engelliyoruz.
    if (btn) {
      btn.addEventListener('click', function (e) {
        if (ready()) return;
        e.preventDefault();
        errorEl.hidden = false;
        errorEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }

    sync();
  }());

  } catch(e) { console.error(e); }
})();
})();
